'use client'

import React from 'react'

import Spinner from '@caffeina-siad/ui-kit/src/components/atoms/Spinner/Spinner.component'

const Loading = () => (
  <Spinner />
)

export default Loading
